/**
 * Report IDs + share links — derived on the client from data already stored
 * on each post (doc id, portal, date). Nothing is written to Firestore.
 *
 *   RPT-MP-2026-A1B2C3
 */
const CODES = {
  mp: 'MP', embedded: 'EMB', system: 'SYS', ops: 'OPS', c_suite: 'CSU',
  payload: 'PAY', pe: 'PE', obc: 'OBC', experimental: 'EXP', finance: 'FIN',
  interns: 'INT',
};

// Public hosting origin — used inside the Android app, where the page origin
// is the WebView's local host and wouldn't open for the recipient.
export const PUBLIC_ORIGIN = 'https://satellite-operating-procedure.web.app';

function postDate(post) {
  const ts = post?.uploadedAt || post?.submittedAt || post?.createdAt;
  if (ts?.toDate) return ts.toDate();
  if (ts?.seconds) return new Date(ts.seconds * 1000);
  const d = ts ? new Date(ts) : null;
  return d && !isNaN(d) ? d : null;
}

export function portalCode(portalId) {
  if (!portalId) return 'GEN';
  return CODES[portalId] || String(portalId).replace(/[^a-z0-9]/gi, '').slice(0, 3).toUpperCase() || 'GEN';
}

export function reportId(post, portalId) {
  if (!post?.id) return '';
  const year = postDate(post)?.getFullYear() || new Date().getFullYear();
  return `RPT-${portalCode(portalId || post.portalId || post.deptId)}-${year}-${post.id.slice(0, 6).toUpperCase()}`;
}

export function reportLink(post, portalPath) {
  if (!post?.id) return '';
  const native = typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.();
  const origin = native ? PUBLIC_ORIGIN : window.location.origin;
  return `${origin}${portalPath || '/'}?post=${encodeURIComponent(post.id)}`;
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (_) {
    // Fallback for WebViews / insecure contexts without the async clipboard
    try {
      const ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (__) { return false; }
  }
}
